import { checkToken } from '~/util/helpers/checkToken'

export default function ({ store, req }) {
  if (process.client) {
    const storeToken = store.getters['user/isLoggedIn']
    !storeToken && store.commit('base/setServerToken', null)
  }
  else {
    const token = checkToken(req)
    token && store.commit('base/setServerToken', token)
  }
}
